<!-- results-table.component.html -->
<h1 mat-dialog-title></h1>
<div mat-dialog-content fxLayout="column">

  <div fxLayout="column" fxFlex="100" class="print">
      <div fxLayout="row" class="p-20">

        <div fxFlex fxLayout="row">
            <div fxFlex="50"><strong>{{organizacion}}</strong></div>
            <div fxFlex="50" fxLayout="column">
                            <div fxFlex fxLayoutAlign="end start">
                <img class="logo-icon" src="assets/images/logos/logo_RIC_horizontal_transparente.png" height="67" width="200" >
              </div>
              <div fxFlex fxLayoutAlign="end start" style="margin-right:20px">
                {{fecha | date:'dd/MM/yyyy'}}
              </div>
        </div>
      </div>
    </div>
  </div>

  <div fxLayout="column" fxFlex="100" >
    <h2 class="p-20" class="print"><strong>Objetivos</strong></h2>

    <table mat-table [dataSource]="objetivos" #mytable class="my-table mat-elevation-z8" class="px-15">

      <ng-container matColumnDef="nombre">
        <th mat-header-cell *matHeaderCellDef> Nombre. </th>
        <td mat-cell *matCellDef="let element"> {{element.nombre}} </td>
      </ng-container>

      <!-- Role Column -->
      <ng-container matColumnDef="descripcion">
        <th mat-header-cell *matHeaderCellDef> Descripcion. </th>
        <td mat-cell *matCellDef="let element"> {{element.descripcion}} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns" class="print"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="print"></tr>
    </table>

  </div>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="printPdf()" [disabled]="disabled">{{'Imprimir' | translate}}</button>
  <button mat-button (click)="closeDialog()" mat-flat-button color="warn">{{'Cancel' | translate}}</button>
</div>
